import { Component } from 'react';
import Draggable from 'react-draggable';
import { ResizableBox } from 'react-resizable';
import './FormDesignItem.css';
import FontAwesomeIcon from '../utils/FontAwesomeIcon';

class FormDesignItem extends Component {
    state = {
    };

    render() {
        let rtl = this.props.rtl === true || (this.props.style?.direction ?? this.props.direction) === 'rtl';
        let sid = this.props.sid ?? this.props.key ?? this.props.text;

        return (
            <Draggable handle='strong' bounds={this.props.bounds ?? 'parent'}
                position={{ x: -(this.props.right ?? 0), y: this.props.top ?? 0 }}
                grid={[this.props.xGridSize ?? 30, this.props.yGridSize ?? 40]}
                {...this.props.draggableProps}
                onStop={(u, v) => {
                    var css = window.getComputedStyle(v.node);
                    let tf = css.getPropertyValue('transform').split(',');
                    let x = Number(css.getPropertyValue('right').replace('px', '')) - Number(tf[4].trim());
                    let y = Number(css.getPropertyValue('top').replace('px', '')) + Number(tf[5].trim().replace(')', ''));
                    console.log(x, y, css.getPropertyValue('transform'));
                    this.props.onDragged?.(x, y, sid, v.node)
                }}
            >
                <div className={this.props.cat === 'section' ? 'box-section' : 'box'}  // no-cursor'
                    style={{
                        height: 'fit-content',
                        margin: '0',
                        padding: '0',
                        borderRadius: '5px',
                        zIndex: '10',
                        position: 'absolute',
                        ...this.props.style
                    }}
                >
                    <ResizableBox className={this.props.cat === 'section' ? 'box-section' : 'box'}
                        width={this.props.width ?? 90} height={this.props.height ?? (this.props.rowSpan ?? 1) * 40}
                        minConstraints={[90, 40]}
                        maxConstraints={[900, this.props.cat === 'complexInput' ? 800 : 40]}
                        style={{ padding: '0', margin: '0', border: 'none' }}
                        resizeHandles={this.props.cat === 'section' ? [] /*'sw', 'se', 'nw', 'ne', 'w', 'e', 'n', 's'*/
                            : this.props.cat === 'complexInput' ? rtl ? ['sw', 'w'] : ['se', 'e']
                                : rtl ? ['w'] : ['e']}
                        draggableOpts={{ grid: [this.props.xGridSize ?? 30, this.props.yGridSize ?? 40] }}
                        onResizeStop={this.props.cat === 'section' ? () => { } : (_, v) => this.props.onResized?.(v.size.width, v.size.height, sid)}
                        {...this.props.resizableProps}
                    >
                        <strong //className='cursor dx-icon-overflow--'
                            style={{
                                cursor: 'move',
                                position: 'absolute',
                                display: 'flex',
                                alignItems: 'center',
                                left: rtl ? false : '5px',
                                right: rtl ? '5px' : false,
                                height: '100%',
                                fontSize: '14px',
                            }}>
                            <FontAwesomeIcon icon='grip-dots-vertical' type='solid' sid={`${this.props.sid}-move-icon`}
                                hint='جابجایی'
                            />
                        </strong>
                        <i //id={`${this.props.sid}-settings-icon`} //className='dx-icon-preferences'
                            onClick={() => this.props.onSettings?.()}
                            style={{
                                color: 'blue',
                                //width: 'fit-content',
                                //height: '100%',
                                position: 'absolute',
                                //top: '0px',
                                left: rtl ? false : '20px',
                                right: rtl ? '20px' : false,
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                fontSize: '14px',
                                cursor: 'pointer',
                                //opacity: '70%',
                            }}
                        >
                            <FontAwesomeIcon icon='gear' type='solid' sid={`${this.props.sid}-settings-icon`}
                                hint='تنظیمات'
                            />
                        </i>
                        {this.props.cat !== 'section' ?
                            <i //id={`${this.props.sid}-valdation-icon`} //className='dx-icon-edit'
                                onClick={() => this.props.onValidation?.()}
                                style={{
                                    color: 'green',
                                    //width: 'fit-content',
                                    //height: '100%',
                                    position: 'absolute',
                                    //top: '0px',
                                    left: rtl ? false : '40px',
                                    right: rtl ? '40px' : false,
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    fontSize: '14px',
                                    cursor: 'pointer',
                                    //opacity: '70%'
                                }}
                            >
                                <FontAwesomeIcon icon='badge-check' hint='اعتبارسنجی' type='solid' sid={`${this.props.sid}-valdation-icon`}
                                />
                            </i>
                            :
                            <i //id={`${this.props.sid}-valdation-icon`} //className='dx-icon-edit'
                                onClick={() => this.props.onHide?.()}
                                style={{
                                    color: 'maroon',
                                    //width: 'fit-content',
                                    //height: '100%',
                                    position: 'absolute',
                                    //top: '0px',
                                    left: rtl ? false : '40px',
                                    right: rtl ? '40px' : false,
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    fontSize: '14px',
                                    cursor: 'pointer',
                                    //opacity: '70%'
                                }}
                            >
                                <FontAwesomeIcon icon='trash' hint='حذف' type='solid' sid={`${this.props.sid}-hide-icon`}
                                />
                            </i>
                        }
                        <i style={{
                            position: 'absolute',
                            right: rtl ? '65px' : false,
                            left: rtl ? false : '65px',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            margin: '0 2px',
                        }}
                        >
                            {this.props.text}
                            {this.props.children}
                        </i>
                    </ResizableBox>
                </div>
            </Draggable >
        );
    }
}

export default FormDesignItem;